import { STRIEP_GATEWAY_EVENTS } from "./Stripe.constants";

export const makePaymentViaStripe = (clientSecret: string) => {
    const listenEv = new CustomEvent(STRIEP_GATEWAY_EVENTS.MAKE_PAYMENT, {
        detail: { clientSecret },
    });
    document.dispatchEvent(listenEv);
};
